import React, { Component, Fragment } from "react";
import RecentChatItem from "./RecentChatItem";
import PropTypes from "prop-types";

export default class RecentChat extends Component {
  getMessageInfo = (recentChatItem) => {
    const { recent: { msgId, fromUserId } = {} } = recentChatItem;
    return {
      msgId,
      fromUserId
    };
  };

  render() {
    const {
      recentChatItems,
      handleConversationSectionDisplay,
      searchTerm,
      callUserJID,
      handleShowCallScreen,
      callType,
      callMode,
      messageData,
      recentChatExist,
    } = this.props;

    if (recentChatItems.length === 0) return null;

    const searchLen = searchTerm?.trim().length;
    const isArchivePage = this.props.pageType === "recent" ? 0 : 1;
    const filteredItems = !searchLen
      ? recentChatItems.filter((item) => item?.recent?.archiveStatus === isArchivePage)
      : recentChatItems;
    return (
      <Fragment>
        <span className="unknown-chat-roster">
          {searchLen > 0 && recentChatExist && <div className="search-head">Chats</div>}
          <ul className="chat-list-ul"
            style={{ display: `${this.props.archiveLength === 0 && this.props.pageType === "archive" ? "none" : ""}` }}>
            {filteredItems.filter(recentChatItem => recentChatItem?.roster?.userId !== this.props?.vCardData?.userId).map((recentChatItem, key) => {
              const { msgId, fromUserId } = this.getMessageInfo(recentChatItem);
              const { hidden = false } = recentChatItem;
              const {roster:{ isAdminBlocked = ""}} = recentChatItem
              return (
                <RecentChatItem
                  pageType={this.props.pageType}
                  enableDropDown={true}
                  key={fromUserId}
                  hidden={hidden}
                  activeClass={false}
                  messageId={msgId}
                  searchTerm={searchTerm}
                  messageData={messageData}
                  handleOnclick={handleConversationSectionDisplay}
                  item={recentChatItem}
                  callUserJID={callUserJID}
                  callStatus={this.props.callStatus}
                  handleShowCallScreen={handleShowCallScreen}
                  callType={callType}
                  callMode={callMode}
                  refreshUnreadCount={this.props.refreshUnreadCount}
                  handlePopupState={this.props.handlePopupState}
                  isAdminBlocked = {isAdminBlocked}
                />
              );
            })}
          </ul>
        </span>
      </Fragment>
    );
  }
}

RecentChat.propTypes = {
  recentChatItems: PropTypes.array,
  handleConversationSectionDisplay: PropTypes.func,
  searchTerm: PropTypes.string,
  callUserJID: PropTypes.string,
  handleShowCallScreen: PropTypes.func,
  callType: PropTypes.string,
  callMode: PropTypes.string,
  messageData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  recentChatExist: PropTypes.bool,
  pageType: PropTypes.string,
  archiveLength: PropTypes.number,
  callStatus: PropTypes.string,
  refreshUnreadCount: PropTypes.bool,
  handlePopupState: PropTypes.func
};